$(document).ready(function(){
  $( '.productView-variants' ).on( 'click', '.custom-size', function () {
    $(".custom-size-chart").show();
    $(".custom-size").addClass("custom-selected");
  });

  $( '.productView-variants' ).on( 'click', '.custom-not', function () {
    $(".custom-size-chart").hide();
    $(".customlable").val('');
    $(".custom-size").removeClass("custom-selected");
  });

  $('.custom_Colors').click(function(){
    $('#swatch-0-chiffon-color-color').trigger('click');
    $('#swatch-0-satin-color-color').trigger('click');
    $('#swatch-0-taffeta-color').trigger('click');
    $('#swatch-0-organza-color').trigger('click');
    $('#swatch-0-charmeuse-color').trigger('click');
    $('#swatch-0-jersey-color').trigger('click');
    $('#swatch-0-satin-chiffon-color').trigger('click');

    
    $(".custom_Colors").removeClass('custom_color_selected');
    $(this).addClass('custom_color_selected');
    $(".custom_Colors").find('input').removeAttr('name');
    $(this).find('input').attr('name', 'testproperties[custom_color]')
    $('#select_custom_color').val($(this).data('color'));
  });

  $('.product-form__radio').click(function(){
    if($(this).hasClass('Color')){
      $('.custom_Colors.custom_color_selected').removeClass('custom_color_selected');
      $('#select_custom_color').val('');
    }
  });
  
  $(".confirm-checkbox").on('click', function() {
    var got = 'true';
   
    if ($("#bust").val() == "" ) {
    $("#bust").css('border', "1.5px solid red");
     var got = 'false'
    }
    else{
     $("#bust").css('border', "1.5px solid #f1f1f1");
    }
      
    if($("#waist").val() == ""){
      $("#waist").css('border', "1.5px solid red");
      var got = 'false'
    }
    else{
     $("#waist").css('border', "1.5px solid #f1f1f1");
    }
    
    if($("#hips").val() == "") {
      $("#hips").css('border', "1.5px solid red");
      var got = 'false'
    }
    else{
     $("#hips").css('border', "1.5px solid #f1f1f1");
    }
    
    if($("#hollow").val() == "") {
      $("#hollow").css('border', "1.5px solid red");
      var got = 'false'
    }
    else{
     $("#hollow").css('border', "1.5px solid #f1f1f1");
    }
    
    if($("#hollow2").val() == "") {
      $("#hollow2").css('border', "1.5px solid red");
      var got = 'false'
    }
    else{
     $("#hollow2").css('border', "1.5px solid #f1f1f1");
    }
    
    if($("#length").val() == "") {
      $("#length").css('border', "1.5px solid red");
      var got = 'false'
    }
    else{
       $("#length").css('border', "1.5px solid #f1f1f1");
    }
    
    if($("#confirma").is(':checked')) {
      $(".confirm").css('border', "1.5px solid #f1f1f1");
    }  
    else{
      $(".confirm").css('border', "1.5px solid red");
    }
  });
});

$(document).ready(function(){
    if ($(window).width() <= 767 ) {
      var color_count = 0;
      $('.custom_Colors_loop').each(function(i){
        color_count++;
        
        $(this).attr('data-ct-color', i);
      });
      
      if(color_count >= 8){
		$('.data_count_value_nw_swatch').text(color_count);
          $('.swatch_count_prd').click(function(){
          $('.custom_Colors_loop').css("display", "inline-block");
          $(this).hide();
          $('.hide_color_swatch').css("display", "inline-block");
        });
        $('.hide_color_swatch').click(function(){
          $('.custom_Colors_loop').css("display", "none");
      	  $(this).hide();
          $('.swatch_count_prd').css("display", "inline-block");
        });
      }
    }

    $('.close-menu-mb').click(function(){
      $('.sub-menu-mobile').removeClass('sub-menu-open');
    });
});


$(".product-form__submit").click(function(e){
    e.preventDefault();
    var got = 'true';
    if($('label.custom-size').hasClass('custom-selected')){
    
    

    if ($("#bust").val() == "" ) {
      $("#bust").css('border', "1.5px solid red");
       var got = 'false'
      }
         else{
       $("#bust").css('border', "1.5px solid #f1f1f1");
      }
      
      if($("#waist").val() == ""){
      $("#waist").css('border', "1.5px solid red");
        var got = 'false'
      } 
         else{
       $("#waist").css('border', "1.5px solid #f1f1f1");
      }
      
      if($("#hips").val() == "") {
      $("#hips").css('border', "1.5px solid red");
        var got = 'false'
      }
         else{
       $("#hips").css('border', "1.5px solid #f1f1f1");
      }
      
      if($("#hollow").val() == "") {
      $("#hollow").css('border', "1.5px solid red");
        var got = 'false'
      }
         else{
       $("#hollow").css('border', "1.5px solid #f1f1f1");
      }
      
      
        if($("#hollow2").val() == "") {
      $("#hollow2").css('border', "1.5px solid red");
          var got = 'false'
      }
         else{
       $("#hollow2").css('border', "1.5px solid #f1f1f1");
      }
      
      if($("#length").val() == "") {
        $("#length").css('border', "1.5px solid red");
        var got = 'false'
      }
      else{
       $("#length").css('border', "1.5px solid #f1f1f1");
      }
       if($("#confirma").is(':checked')) {
        $(".confirm").css('border', "1.5px solid #f1f1f1");
      }  
      else{
      
      $(".confirm").css('border', "1.5px solid red");
      }
    }

  var selectedColor = jQuery('#SingleOptionSelector-0').val();
    var checkWord = 'color';
    var CustomColor = '';
    if(selectedColor.indexOf(checkWord) != -1){
      if(jQuery('#custom_color_h').val()==1){
        if(jQuery('[name="testproperties[custom_color]"]').length==1){
          CustomColor = jQuery('[name="testproperties[custom_color]"]').val();
        }else{
          got='false'; 
        }
      }else{
        got='false';
      }
     }
    if(got=='false'){
      jQuery('.cart-button-error').remove();
      jQuery('.product-add-to-cart').parent('div').after('<p class="cart-button-error" style="color:#FF0000;"><b>Please choose a color and size.</b></p>');
    } 

    if(got == 'true')
      return true;
    else
      return false;
});

